export enum AppRoutes {
  LoginForm = 'auth/login',
  Agent = 'agent',
  ReportsViewer = 'reports-viewer',
  PWA = 'pwa',
  Web = 'web',
  DeviceLanding = 'device-landing',
  PagesAdministration = 'pages-administration',
  TemplatesBuilder = 'templates-builder',
  FormsBuilder = 'forms-builder',
}
